import React, { useState, useContext } from "react";
import { LanguageContext } from "../../Components/LanguageContext";
import translations from "./translation.json";
import "./ContactUs.css";
import { useFormik } from "formik";
import { axiosInstance } from "../../axiosInstance";
import { toast, ToastContainer } from "react-toastify";
import Preloader from "../../Components/Loader/Loader";
import * as Yup from "yup";


const validationSchema = Yup.object().shape({
  message : Yup.string().required("Please enter your report"),

})


export function ContactUs() {
  const [loading, setLoading] = useState(false);
  const { language } = useContext(LanguageContext);

  const formik = useFormik({
    initialValues: {
      message: "",
    },
    validationSchema:validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.post("customer-contact", values);
        if (response.data.status === true) {
          toast.success(
            response.data.message || "Request is Submitted successfully.."
          );
          resetForm();
          setLoading(false);
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
        setLoading(false);
      }
    },
  });

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="contactBg">
        <form onSubmit={formik.handleSubmit}>
          <div className="container contact-content">
            <div className="contact-text">{translations[language].contact}</div>
            <div className="contact-number">+91 8978260525</div>
            <div className="contact-email">support@nathicharami.in</div>
            <div className="contact-write">{translations[language].write} <span className="text-danger">*</span></div>
            <div className="contact-report">
              <textarea
                placeholder="Type here"
                rows={4}
                onChange={formik.handleChange}
                name="message"
                value={formik.values.message}
              ></textarea>
               <div>
                  {formik.touched.message && formik.errors.message && (
                    <div className="text-danger">{formik.errors.message}</div>
                  )}
                </div>
            </div>
            <div className="btnSendMessage">
              <button>{translations[language].btnsendmessage}</button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
